import {SalesManager, SalesRepresentative} from 'Component/Chat/Chat.type';
import {awCaGetCompanyForCurrentCustomer, companyUsersOutput} from 'Query/MyAccountCompany.type';
import {
    MyAccountCompanyActionType,
    updateAccountCompanyInfoAction,
    updateCompanyUsersListAction,
    updateSalesManagerAction,
    updateSalesRepresentativeAction, updateSelectedDeliveryDayAction,
} from 'Store/MyAccountCompany/MyAccountCompany.type';

/** @namespace Steinkrueger/Store/MyAccountCompany/Action/updateAccountCompanyInfo */
export const updateAccountCompanyInfo = (
    awCaGetCompanyForCurrentCustomer: awCaGetCompanyForCurrentCustomer,
): updateAccountCompanyInfoAction => ({
    type: MyAccountCompanyActionType.UPDATE_MY_ACCOUNT_COMPANY_INFO,
    awCaGetCompanyForCurrentCustomer,
});

/** @namespace Steinkrueger/Store/MyAccountCompany/Action/updateSalesRepresentative */
export const updateSalesRepresentative = (
    salesRepresentative: SalesRepresentative,
): updateSalesRepresentativeAction => ({
    type: MyAccountCompanyActionType.UPDATE_SALES_REPRESENTATIVE,
    salesRepresentative,
});

/** @namespace Steinkrueger/Store/MyAccountCompany/Action/updateSalesManager */
export const updateSalesManager = (
    salesManager: SalesManager,
): updateSalesManagerAction => ({
    type: MyAccountCompanyActionType.UPDATE_SALES_MANAGER,
    salesManager,
});

/** @namespace Steinkrueger/Store/MyAccountCompany/Action/updateCompanyUsersList */
export const updateCompanyUsersList = (
    companyUsersList: companyUsersOutput,
): updateCompanyUsersListAction => ({
    type: MyAccountCompanyActionType.UPDATE_COMPANY_USERS_LIST,
    companyUsersList,
});

/** @namespace Steinkrueger/Store/MyAccountCompany/Action/updateSelectedDeliveryDay */
export const updateSelectedDeliveryDay = (
    selectedDeliveryDay: string,
): updateSelectedDeliveryDayAction => ({
    type: MyAccountCompanyActionType.UPDATE_SELECTED_DELIVERY_DAY,
    selectedDeliveryDay,
});
